import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'PhoneNumberPipe',
})
export class PhoneNumberPipe implements PipeTransform {
    constructor() {}
    transform(value: string): string {
        if (!value) {
            return value
        }
        // return '0' + value.toString().trim().replace(/^0+/, '')
        if (value?.match(/^\d{10}$/g)) {
            return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6)}`
        }
        return value.toString()
    }
}
